"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityNurseListCountsDto = instanceOfFacilityNurseListCountsDto;
exports.FacilityNurseListCountsDtoFromJSON = FacilityNurseListCountsDtoFromJSON;
exports.FacilityNurseListCountsDtoFromJSONTyped = FacilityNurseListCountsDtoFromJSONTyped;
exports.FacilityNurseListCountsDtoToJSON = FacilityNurseListCountsDtoToJSON;
exports.FacilityNurseListCountsDtoToJSONTyped = FacilityNurseListCountsDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityNurseListCountsDto interface.
 */
function instanceOfFacilityNurseListCountsDto(value) {
    if (!('myNurses' in value) || value['myNurses'] === undefined)
        return false;
    if (!('blocked' in value) || value['blocked'] === undefined)
        return false;
    if (!('interested' in value) || value['interested'] === undefined)
        return false;
    return true;
}
function FacilityNurseListCountsDtoFromJSON(json) {
    return FacilityNurseListCountsDtoFromJSONTyped(json, false);
}
function FacilityNurseListCountsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'myNurses': json['myNurses'],
        'blocked': json['blocked'],
        'interested': json['interested'],
    };
}
function FacilityNurseListCountsDtoToJSON(json) {
    return FacilityNurseListCountsDtoToJSONTyped(json, false);
}
function FacilityNurseListCountsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'myNurses': value['myNurses'],
        'blocked': value['blocked'],
        'interested': value['interested'],
    };
}
//# sourceMappingURL=FacilityNurseListCountsDto.js.map